import { render, staticRenderFns } from "./predictionWorkspace.vue?vue&type=template&id=ca035ac8&"
import script from "./predictionWorkspace.vue?vue&type=script&lang=js&"
export * from "./predictionWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca035ac8')) {
      api.createRecord('ca035ac8', component.options)
    } else {
      api.reload('ca035ac8', component.options)
    }
    module.hot.accept("./predictionWorkspace.vue?vue&type=template&id=ca035ac8&", function () {
      api.rerender('ca035ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/Prediction/predictionWorkspace.vue"
export default component.exports